const IndicesFrequency = {
    DAILY: 'daily',
    WEEKLY: 'weekly',
};

export { IndicesFrequency };



// WEBPACK FOOTER //
// ./source/constants/indices.js